import {ValueObject} from '@s-ui/domain'

export class VideoResourcesValueObject extends ValueObject {
  #autoPlay
  #externalId
  #position
  #provider
  #url

  constructor({autoPlay, externalId, position, provider, url}) {
    super()
    this.#autoPlay = autoPlay
    this.#externalId = externalId
    this.#position = position
    this.#provider = provider
    this.#url = url
  }

  static createFromLiterals({autoPlay, externalId, position, provider, url}) {
    return new VideoResourcesValueObject({
      autoPlay,
      externalId,
      position,
      provider,
      url
    })
  }

  get autoPlay() {
    return this.#autoPlay
  }

  get externalId() {
    return this.#externalId
  }

  get position() {
    return this.#position
  }

  get provider() {
    return this.#provider
  }

  get url() {
    return this.#url
  }

  get value() {
    return {
      autoPlay: this.autoPlay,
      externalId: this.externalId,
      position: this.position,
      provider: this.provider,
      url: this.url
    }
  }
}
